var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookmark = function SvgIconBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060D26",
    fillRule: "evenodd",
    d: "M7.812 2a3 3 0 0 0-3 3v16a1 1 0 0 0 1.581.814l6.419-4.585 6.419 4.585A1 1 0 0 0 20.812 21V5a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBookmark;